import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarOptions } from 'owa-calendar-processing-configuration';

/*
    Gets the fallback value for old meeting notification option in calendar events and invitation settings
*/
export default function getOldMeetingMessageOption() {
    return getFallbackValueIfNull(
        store().removeOldMeetingMessages,
        getCalendarOptions().RemoveOldMeetingMessages
    );
}
